import Swiper from 'swiper';
import 'swiper/css';

const Portfiolio = () => {
    const components = document.querySelectorAll('[data-component="portifolio"]');

    components.forEach(component => {
        const swiperComponent = component.querySelector('.swiper');

        const swiper = new Swiper(swiperComponent, {
            loop: false,
            slidesPerView: 'auto',
            spaceBetween: 12,
            breakpoints: {
                0: {
                    slidesOffsetBefore: 16,
                    slidesOffsetAfter: 16,
                },
                1280: {
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 400,
                }
            }
        });

        // --- FILTRO DE ABAS (botões + select) ---
        const buttons = component.querySelectorAll('.aba-item');
        const select = component.querySelector('.aba-select');
        const slides = component.querySelectorAll('.swiper-slide');

        function applyFilter(filter) {
            // ativa botões desktop
            if (buttons.length) {
                buttons.forEach(b => {
                    if (b.dataset.filter === filter) {
                        b.classList.add('active');
                    } else {
                        b.classList.remove('active');
                    }
                    if (filter === 'all') {
                        buttons[0].classList.add('active'); // garante "Mais Recentes"
                    }
                });
            }

            // filtra slides
            slides.forEach(slide => {
                if (filter === 'all' || slide.dataset.filter === filter) {
                    slide.style.display = '';
                } else {
                    slide.style.display = 'none';
                }
            });

            swiper.update();
        }

        // botões desktop
        buttons.forEach(btn => {
            btn.addEventListener('click', () => {
                applyFilter(btn.dataset.filter);
            });
        });

        // select mobile
        if (select) {
            select.addEventListener('change', e => {
                applyFilter(e.target.value);
            });
        }
    });
};

export default Portfiolio;

if (document.querySelectorAll('[data-component="portifolio"]').length) {
    Portfiolio();
}
